import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLightbulb",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], h = ["clip-path"], m = ["id"];
function p(e, t, r, _, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--lightbulb"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Lightbulb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M3.525 1.525A3.5 3.5 0 0 1 9.5 3.996a2.825 2.825 0 0 1-.903 2.115c-.325.326-.493.617-.56.98a.5.5 0 1 1-.984-.181c.113-.615.413-1.082.844-1.513A1.825 1.825 0 0 0 8.5 4.009V4a2.5 2.5 0 1 0-5 0c0 .398.081.872.596 1.39.435.401.732.931.849 1.513a.5.5 0 0 1-.981.195 1.805 1.805 0 0 0-.568-.994C2.647 5.354 2.5 4.6 2.5 4a3.5 3.5 0 0 1 1.025-2.475ZM4 9a.5.5 0 0 1 .5-.5h3a.5.5 0 1 1 0 1h-3A.5.5 0 0 1 4 9Zm.5 2a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, h),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, f);
}
const S = /* @__PURE__ */ u(c, [["render", p]]);
export {
  S as default
};
//# sourceMappingURL=lightbulb.js.map
